import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39bc63b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Como você avalia esse pedido? ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Como você avalia esse aplicativo? ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Você encontrou tudo o que estava procurando? ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Enviar Avaliação")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_layout",
  src: "/assets/icon/historico.svg"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Histórico de Pedidos ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Pedidos Recentes ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " Nenhum pedido encontrado ", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode()
const _hoisted_14 = { class: "font-montserrat" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Entregue ")
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" pedido cancelado ")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = { class: "font-montserrat-bold bold total" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_Pedido = _resolveComponent("Pedido")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_SafeArea = _resolveComponent("SafeArea")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_modal, {
        "is-open": _ctx.isOpenRef,
        onDidDismiss: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenRef = false))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        color: "dark",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOpen(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconFechar }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_Pedido, {
                pedido: _ctx.meuspedidos.selecionado,
                onOnAvaliar: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpenAvaliacao=true))
              }, null, 8, ["pedido"]),
              _hoisted_1,
              _hoisted_2,
              _hoisted_3,
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        ref: "modal_avaliacao",
        "is-open": _ctx.isOpenAvaliacao,
        onDidDismiss: _cache[20] || (_cache[20] = ($event: any) => (_ctx.isOpenAvaliacao = false)),
        "initial-breakpoint": 0.80,
        breakpoints: [0, 0.80]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "font-montserrat-bold layout_blue",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.iconAvaliacao }, null, 8, ["icon"]),
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.meuspedidos.selecionado.current_rating.nota_geral=1)),
                        size: "small",
                        color: _ctx.meuspedidos.selecionado.current_rating.nota_geral > 0 ? 'jauservelayoutalter':'jauservelayoutciza6',
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconStar }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.meuspedidos.selecionado.current_rating.nota_geral=2)),
                        size: "small",
                        color: _ctx.meuspedidos.selecionado.current_rating.nota_geral > 1 ? 'jauservelayoutalter':'jauservelayoutciza6',
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconStar }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.meuspedidos.selecionado.current_rating.nota_geral=3)),
                        size: "small",
                        color: _ctx.meuspedidos.selecionado.current_rating.nota_geral > 2 ? 'jauservelayoutalter':'jauservelayoutciza6',
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconStar }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.meuspedidos.selecionado.current_rating.nota_geral=4)),
                        size: "small",
                        color: _ctx.meuspedidos.selecionado.current_rating.nota_geral > 3 ? 'jauservelayoutalter':'jauservelayoutciza6',
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconStar }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.meuspedidos.selecionado.current_rating.nota_geral=5)),
                        size: "small",
                        color: _ctx.meuspedidos.selecionado.current_rating.nota_geral > 4 ? 'jauservelayoutalter':'jauservelayoutciza6',
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconStar }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["color"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "font-montserrat-bold layout_blue",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.iconAvaliacao }, null, 8, ["icon"]),
                      _createTextVNode(" Como você avalia a " + _toDisplayString(_ctx.meuspedidos.selecionado.shipments[0].shipping_method.name.toLowerCase()=="receba em casa"?'entrega':"retirada na loja") + "? ", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.meuspedidos.selecionado.current_rating.nota_entrega=1)),
                        size: "small",
                        color: _ctx.meuspedidos.selecionado.current_rating.nota_entrega > 0 ? 'jauservelayoutalter':'jauservelayoutciza6',
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconStar }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.meuspedidos.selecionado.current_rating.nota_entrega=2)),
                        size: "small",
                        color: _ctx.meuspedidos.selecionado.current_rating.nota_entrega > 1 ? 'jauservelayoutalter':'jauservelayoutciza6',
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconStar }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.meuspedidos.selecionado.current_rating.nota_entrega=3)),
                        size: "small",
                        color: _ctx.meuspedidos.selecionado.current_rating.nota_entrega > 2 ? 'jauservelayoutalter':'jauservelayoutciza6',
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconStar }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.meuspedidos.selecionado.current_rating.nota_entrega=4)),
                        size: "small",
                        color: _ctx.meuspedidos.selecionado.current_rating.nota_entrega > 3 ? 'jauservelayoutalter':'jauservelayoutciza6',
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconStar }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.meuspedidos.selecionado.current_rating.nota_entrega=5)),
                        size: "small",
                        color: _ctx.meuspedidos.selecionado.current_rating.nota_entrega > 4 ? 'jauservelayoutalter':'jauservelayoutciza6',
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconStar }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["color"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "font-montserrat-bold layout_blue",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.iconAvaliacao }, null, 8, ["icon"]),
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.meuspedidos.selecionado.current_rating.nota_aplicativo=1)),
                        size: "small",
                        color: _ctx.meuspedidos.selecionado.current_rating.nota_aplicativo > 0 ? 'jauservelayoutalter':'jauservelayoutciza6',
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconStar }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.meuspedidos.selecionado.current_rating.nota_aplicativo=2)),
                        size: "small",
                        color: _ctx.meuspedidos.selecionado.current_rating.nota_aplicativo > 1 ? 'jauservelayoutalter':'jauservelayoutciza6',
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconStar }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.meuspedidos.selecionado.current_rating.nota_aplicativo=3)),
                        size: "small",
                        color: _ctx.meuspedidos.selecionado.current_rating.nota_aplicativo > 2 ? 'jauservelayoutalter':'jauservelayoutciza6',
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconStar }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.meuspedidos.selecionado.current_rating.nota_aplicativo=4)),
                        size: "small",
                        color: _ctx.meuspedidos.selecionado.current_rating.nota_aplicativo > 3 ? 'jauservelayoutalter':'jauservelayoutciza6',
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconStar }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.meuspedidos.selecionado.current_rating.nota_aplicativo=5)),
                        size: "small",
                        color: _ctx.meuspedidos.selecionado.current_rating.nota_aplicativo > 4 ? 'jauservelayoutalter':'jauservelayoutciza6',
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.iconStar }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["color"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "font-montserrat-bold layout_blue",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.iconAvaliacao }, null, 8, ["icon"]),
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center font-montserrat-bold layout_blue",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_textarea, {
                        modelValue: _ctx.meuspedidos.selecionado.current_rating.comentario,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.meuspedidos.selecionado.current_rating.comentario) = $event)),
                        placeholder: "Escreva aqui sua se faltou algo"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center font-montserrat-bold layout_blue",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.loadingAvaliar)
                        ? (_openBlock(), _createBlock(_component_ion_button, {
                            key: 0,
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sendAvaliacao())),
                            color: "jauservelayoutalter",
                            shape: "jau"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_ion_button, {
                            key: 1,
                            color: "jauservelayoutalter",
                            shape: "round"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_spinner, { name: "circular" })
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(_component_SafeArea, {
        onOnBack: _cache[21] || (_cache[21] = ($event: any) => (_ctx.voltar())),
        data: {'cart': false}
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                class: "ion-text-start font-montserrat font-30 layout_blue"
              }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.loadingPedidos)
            ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_skeleton_text, {
                        animated: true,
                        style: {"width":"80px"}
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_skeleton_text, { animated: true })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", null, [
                            _createVNode(_component_ion_skeleton_text, {
                              animated: true,
                              style: {"width":"80%"}
                            })
                          ]),
                          _createElementVNode("p", null, [
                            _createVNode(_component_ion_skeleton_text, {
                              animated: true,
                              style: {"width":"60%"}
                            })
                          ]),
                          _createElementVNode("p", null, [
                            _createVNode(_component_ion_skeleton_text, {
                              animated: true,
                              style: {"width":"30%"}
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_skeleton_text, { animated: true })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", null, [
                            _createVNode(_component_ion_skeleton_text, {
                              animated: true,
                              style: {"width":"80%"}
                            })
                          ]),
                          _createElementVNode("p", null, [
                            _createVNode(_component_ion_skeleton_text, {
                              animated: true,
                              style: {"width":"60%"}
                            })
                          ]),
                          _createElementVNode("p", null, [
                            _createVNode(_component_ion_skeleton_text, {
                              animated: true,
                              style: {"width":"30%"}
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_skeleton_text, { animated: true })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", null, [
                            _createVNode(_component_ion_skeleton_text, {
                              animated: true,
                              style: {"width":"80%"}
                            })
                          ]),
                          _createElementVNode("p", null, [
                            _createVNode(_component_ion_skeleton_text, {
                              animated: true,
                              style: {"width":"60%"}
                            })
                          ]),
                          _createElementVNode("p", null, [
                            _createVNode(_component_ion_skeleton_text, {
                              animated: true,
                              style: {"width":"30%"}
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_list_header, null, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              (_ctx.meuspedidos.pedidos.length==0)
                ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meuspedidos.pedidos, (pedido, index) => {
                return (_openBlock(), _createBlock(_component_ion_item, {
                  id: "open-modal",
                  onClick: ($event: any) => (_ctx.pedidoSelecionado(pedido)),
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_note, {
                      slot: "start",
                      color: "jauservelayoutalter"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.toDia(pedido.creation_date)), 1),
                        _hoisted_13,
                        _createElementVNode("span", null, _toDisplayString(_ctx.toMese(pedido.creation_date)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", _hoisted_14, _toDisplayString('Pedido #' + pedido.order_no), 1),
                        _createElementVNode("p", null, _toDisplayString(pedido.shipments[0].shipping_method.name), 1),
                        (pedido.status != 'failed' && pedido.status != 'cancelled')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              (pedido.shipping_status=='not_shipped')
                                ? (_openBlock(), _createBlock(_component_ion_badge, {
                                    key: 0,
                                    color: pedido.shipments[0].tipo == 2 ? 'warning' : 'jauservelayoutvermelho'
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(pedido.shipments[0].method_name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"]))
                                : (_openBlock(), _createBlock(_component_ion_badge, {
                                    key: 1,
                                    color: "jauservelayoutverde"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_16
                                    ]),
                                    _: 1
                                  }))
                            ]))
                          : _createCommentVNode("", true),
                        (pedido.status == 'failed' ||  pedido.status == 'cancelled' )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createVNode(_component_ion_badge, { color: "warning" }, {
                                default: _withCtx(() => [
                                  _hoisted_18
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ion_note, {
                      slot: "end",
                      color: "jauservelayoutalter"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_19,
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$cart.currencyUSD(pedido.order_total)), 1),
                        _hoisted_21,
                        _hoisted_22
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}